export enum JobPostingInterviewMultipleChoiceTypes {
    singleSelect = 'Single-select',
    multiSelect = 'Multi-select',
}
